import { makeStyles } from "@material-ui/core/styles";

export const useTableStyles = makeStyles(
  theme => ({
    boxStyles: {
      alignItems: "center",
      display: "flex",
      height: "50vh",
      justifyContent: "center",
      width: "100%"
    },
    boxStylesForNonTableFormat: {
      height: "100%"
    },
    bulkActionModalDisableConfirmBtn: {
      "&:disabled": {
        opacity: 0.5
      },
      "&:hover": {
        backgroundColor: "#F4F8FF",
        border: "none",
        boxShadow: "none"
      },
      backgroundColor: "#F4F8FF",
      border: "none",
      borderRadius: "6px"
    },
    bulkActionModalDisableConfirmTxt: {
      color: "#EC5D77 !important"
    },
    bulkActionModalDisableDiscardBtn: {
      "&:disabled": {
        opacity: 0.5
      },
      "&:hover": {
        backgroundColor: "#9098A1",
        border: "none",
        boxShadow: "none"
      },
      backgroundColor: "#9098A1",
      border: "none",
      borderRadius: "6px"
    },
    bulkActionModalEnableDiscardBtn: {
      "&:disabled": {
        opacity: 0.5
      },
      "&:hover": {
        backgroundColor: "#E8EAEE",
        border: "none",
        boxShadow: "none"
      },
      backgroundColor: "#E8EAEE",
      border: "none",
      borderRadius: "6px"
    },
    bulkActionModalEnableDiscardTxt: {
      color: "#494E56 !important"
    },
    bulkActionModalTitleText: {
      fontSize: "24px",
      fontWeight: 700,
      margin: "0px 0px 25px",
      textAlign: "center"
    },
    checkIcon: {
      color: "#00c6a2",
      cursor: "pointer",
      height: "20px",
      marginLeft: "auto"
    },
    colStatus: {
      width: "auto",
      [theme.breakpoints.down("md")]: {
        width: "auto"
      }
    },
    content: {},
    cursorHand: {
      color: "#000",
      cursor: "pointer"
    },

    dataDisplay: {},
    dataOrderCode: {
      flexGrow: 1,
      fontWeight: 600
    },
    dataOrderCodeContainer: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    },
    dataTenantBrand: {
      fontSize: "12px"
    },
    dataTitle: {
      display: "none !important"
    },
    divFlex: {
      display: "flex"
    },

    footerActions: {
      alignItems: "flex-end",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      width: "100%"
    },
    footerBtn: {
      "& span": {
        color: "#ffffff"
      },
      "&.outlined": {
        "&:hover": {
          backgroundColor: "#ffffff"
        },
        backgroundColor: "#ffffff",
        border: "2px solid #0030FF"
      },
      "&.outlined span": {
        color: "#0030FF !important"
      },
      "&:hover": {
        backgroundColor: "#0030FF"
      },
      "&:hover span": {
        color: "#ffffff"
      },
      "&:last-child": {
        marginLeft: "10px"
      },

      backgroundColor: "#0030FF",
      color: "#ffffff"
    },

    remittanceCheckbox: {
      "&.Mui-disabled": {
        "& .MuiSvgIcon-root": {
          "& .innerBox": { fill: "#3D3D3D80" },
          "& path": { fill: "transparent" }
        },
        color: "#3D3D3D80"
      },
      color: "#1848FE"
    },
    remittanceDataDisplay: {
      textDecoration: "underline"
    },
    remittanceDataValue: {
      alignItems: "center",
      color: "#247CFF",
      cursor: "pointer",
      display: "inline-flex",
      textDecoration: "underline"
    },
    remittanceDataValueDefault: {
      color: "#000",
      textDecoration: "none !important"
    },
    responsiveTable: {
      overflow: "auto !important"
    },
    tableBody: {
      height: "50vh"
    },
    tableCellBody: {
      [theme.breakpoints.down("lg")]: {
        fontSize: "14px"
      }
    },
    tableCellCenter: {
      textAlign: "center"
    },
    tableCellHeader: {
      fontSize: "14px",
      fontWeight: 400,
      [theme.breakpoints.down("lg")]: {
        fontSize: "1em"
      }
    },
    tableHeaderCenter: {
      textAlign: "center"
    },
    tableHeaderTitle: {
      fontSize: "18px",
      fontWeight: 400
    },

    tableRoot: {
      "@media (min-width: 1440px)": {
        height: "35vh"
      },
      "@media (min-width: 926px)": {
        height: "50vh",
        overflowX: "auto"
      },
      [theme.breakpoints.down("md")]: {
        "& thead, tbody, th, td, tr": {
          border: "none"
        },
        "& tr": {
          backgroundColor: "#fff !important",
          borderBottom: "1px solid #ccc",
          paddingBottom: "30px",
          paddingTop: "30px"
        }
      },
      height: "685px",
      overflowX: "auto",
      tableLayout: "auto"
    },

    textCenter: {
      textAlign: "center"
    },
    toRemitTableForLoading: {
      height: "35vh",
      overflow: "hidden !important"
    },

    [theme.breakpoints.down("sm")]: {
      dataGroup: {},
      dataTitle: {}
    }
  }),
  { name: "RemittanceRunnerTableStyles" }
);
